import StatusPill from "shared/StatusPill";
import type { CompanyStanding } from "../api/CrmApi";

const LABEL: Record<CompanyStanding["kind"], string> = { warm: "Warm", teaming: "Teaming partner", declined: "Not interested at all" };
const WHAT: Record<CompanyStanding["kind"], string> = {
  warm: "wants to work with us. It gets no cold email or LinkedIn message: a person writes to it.",
  teaming: "is already our partner. It gets no cold email or LinkedIn message.",
  declined: "said it is not interested at all. It gets no cold email or LinkedIn message on any RFP until a person changes that conversation's result.",
};

/** What the conversation results say about the whole company (Warm, Teaming partner, Not interested at all), with the RFP and date in the tooltip. */
export default function CompanyStandingBadge({ standing }: { standing?: CompanyStanding | null }) {
  if (!standing) return null;
  const when = standing.outcome_at ? ` on ${standing.outcome_at.slice(0, 10)}` : "";
  const rfp = standing.rfp_title ? ` (RFP: ${standing.rfp_title})` : "";
  const note = standing.note ? ` Note: ${standing.note}` : "";
  return (
    <StatusPill tone={standing.kind === "declined" ? "neutral" : "success"} size="sm" title={`This company ${WHAT[standing.kind]} Set${when}${rfp}.${note}`}>
      {LABEL[standing.kind]}
    </StatusPill>
  );
}
